
import { defineComponent, PropType } from '@vue/composition-api';
import Icon from '../icons.vue';
import {
  formatSecondsToTime,
  formatSecondsToTimeWithMinutes
} from '@/composables/utils';
import { LivescoreIncident } from '../../../../../types/sport';
import IncidentsCodes from '../../IncidentsCodes.json';

export default defineComponent({
  name: 'EventItem',
  components: { Icon },
  props: {
    incident: {
      type: Object as PropType<LivescoreIncident>,
      required: false
    },
    sportId: {
      type: Number,
      required: true
    }
  },
  methods: {
    formatSecondsToTimeWithMinutes
  },
  data() {
    return {
      incidentsCodes: IncidentsCodes
    };
  }
});
